<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <div class="col-md-12 px-0">
      <report-filters 
        :creators="creators"
        :services="services"
        @submit="submit"    
        @update-filter="updateFilter"
      />
    </div>
    <div class="col-md-12 px-0">
      <the-table
        id="milk-report"
        :dataItems="computedResults"
        :headers="headersForTable"
      ></the-table>
    </div>

    <button-export
      :print="true"
      @print="PDFPrint"
      v-if="computedResults.length"
      :excel="true"
      :data="computedExcel"
      :title="'Relatório de Analíse de Leite'"
      @export-pdf="PDFExport"
    />
  </div>  
</template>

<script>
import ReportFilters from "./ReportFilters.vue";
import TheTable from "@/components/layout/TheTable.vue";
import ButtonExport from "@/components/layout/ButtonExport";
import {mapState, mapActions} from "vuex";
import { exportOfficialTablePdf } from "@/utils/officialPdf";
export default {
  name:"MilkReport",
  components: {
    ReportFilters,
    TheTable,
    ButtonExport
  },
  data() {
    return {
      headersForTable:[
        {text:"Lactação", value:"lactation"},
        {text:"CCS Médio", value:"ccs"},
        {text:"CBT Médio", value:"cbt"},
        {text:"Lactose Médio", value:"lactose"},
        {text:"Gordura Médio", value:"fat"},
        {text:"Proteína Médio", value:"protein"},
      ],
      filter:{}
    }
  },
  computed: {
    ...mapState("creators", ["creators"]),
    ...mapState("service", ["services"]),
    ...mapState("milk_analysis_report", ["results"]),
    computedResults() {
      if(this.results.analysis) {
        return this.results.analysis;
      } else {
        return [];
      }
    },
    computedExcel() {
      return this.computedResults.map(e => ({
        "Lactação":e.lactation,
        "CCS Médio":e.ccs,
        "CBT Médio":e.cbt,
        "Gordura Médio":e.fat,
        "Lactose Médio":e.lactose,
        "Proteína Médio":e.protein
      }));
    }
  },
  methods: {
    ...mapActions("creators", ["actionGetCreators"]),
    ...mapActions("service", ["actionGetServices"]),
    ...mapActions("milk_analysis_report", ["actionGetMilkAnalysisReport"]),
    async submit(service) {
      await this.actionGetMilkAnalysisReport(service);
    },
    updateFilter(data) {
      this.filter = data;
    },
    async PDFExport(print = false) {
      const { date, date_end, person_id, service_id } = this.filter;
      const creator = this.creators.find(person => person.id === person_id);
      const service = this.services.find(item => item.id === service_id);
      return exportOfficialTablePdf({
        table: "#milk-report", title: "RELATÓRIO DE ANÁLISES DO LEITE",
        details: [
          date && date_end ? `Período: ${date} até ${date_end}` : `Serviço: ${service?.date || "-"}    Nº ${service?.code || "-"}`,
          `Criador: ${creator?.name || service?.person?.name || "-"}`
        ],
        filename: `relatorio_analises_leite_${Date.now()}.pdf`, print
      });
    },
    async PDFPrint() {
      await this.PDFExport(true);
    },
  },
  async mounted() {
    await this.actionGetCreators();
    await this.actionGetServices({summary:true});
  }
}
</script>
